import { en } from './en';
import { ru } from './ru';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';
import { it } from './it';
import { pt } from './pt';
import { pl } from './pl';
import { zh } from './zh';
import { ja } from './ja';
import { ko } from './ko';

export const translations = {
  en,
  ru,
  es,
  fr,
  de,
  it,
  pt,
  pl,
  zh,
  ja,
  ko
};

export type SupportedLanguage = keyof typeof translations;
export type TranslationKeys = typeof en;

export const defaultLanguage: SupportedLanguage = 'en';
